import { createSelector } from '../../dependencies';
import { selectExpenses } from './expenses';

export const duplicateExpenseIdSelector = createSelector(
    selectExpenses,
    expenses => expenses.duplicateExpense,
);
